var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* eslint-disable comma-dangle, no-var, react/sort-comp */
/* TODO(csilvers): fix these lint errors (http://eslint.org/docs/rules): */
/* To fix, remove an entry above, run ka-lint, and fix errors. */

var React = require("react");

var Changeable = require("../mixins/changeable.jsx");
var EditorJsonify = require("../mixins/editor-jsonify.jsx");

var ExampleGraphieWidget = require("./example-graphie-widget.jsx").widget;

/**
 * This is the widget's editor. This is what shows up on the left side
 * of the screen in the demo page. Only the question writer sees this.
 */
var ExampleGraphieWidgetEditor = React.createClass({
    displayName: "ExampleGraphieWidgetEditor",

    propTypes: _extends({}, Changeable.propTypes),

    getDefaultProps: function getDefaultProps() {
        return {
            correct: [4, 4],
            graph: {
                box: [340, 340],
                labels: ["x", "y"],
                range: [[-10, 10], [-10, 10]],
                step: [1, 1],
                gridStep: [1, 1],
                valid: true,
                backgroundImage: null,
                markings: "grid",
                showProtractor: false
            }
        };
    },

    render: function render() {
        return React.createElement(
            "div",
            null,
            React.createElement(ExampleGraphieWidget, {
                graph: this.props.graph,
                coord: this.props.correct,
                onChange: this.handleChange,
                apiOptions: this.props.apiOptions
            })
        );
    },

    change: function change() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return Changeable.change.apply(this, args);
    },


    handleChange: function handleChange(newProps) {
        if (newProps.coord) {
            this.change({
                correct: newProps.coord
            });
        }
    },

    serialize: function serialize() {
        return EditorJsonify.serialize.call(this);
    }
});

module.exports = ExampleGraphieWidgetEditor;


/*****************
 ** WEBPACK FOOTER
 ** ./src/widgets/example-graphie-widget-editor.jsx
 ** module id = 159
 ** module chunks = 0 1
 **/